// <quick-order-sheet>: tapping a product card ([data-quick-order]) opens its personalise form in a sheet,
// so people order straight from the home page. The form is the product page's own (sections/quick-order).

import '@theme/product-configurator';
import '@theme/product-gallery';
import { openOverlay } from '@theme/utils';

class QuickOrderSheet extends HTMLElement {
  connectedCallback() {
    this.panel = this.querySelector('.sheet');
    this.body = this.querySelector('[data-sheet-body]');
    document.addEventListener('click', (event) => {
      const link = event.target.closest('[data-quick-order]');
      // Let new-tab clicks behave like normal links.
      if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.button) return;
      event.preventDefault();
      this.open(link.href);
    });
    document.addEventListener('cart:changed', (event) => {
      if (event.detail?.source === 'add') this.close?.();
    });
    this.querySelector('[data-close-sheet]').addEventListener('click', () => this.close?.());
  }

  async open(productUrl) {
    this.body.innerHTML = '<div class="sheet__loading"><span class="spinner"></span>Loading…</div>';
    if (!this.close) this.close = openOverlay(this.panel, { onClose: () => { this.close = null; } });
    const url = new URL(productUrl, window.location.origin);
    url.searchParams.set('section_id', 'quick-order');
    const html = await fetch(url).then((r) => (r.ok ? r.text() : Promise.reject(r.status))).catch(() => null);
    if (!html) {
      window.location.href = productUrl; // fall back to the full product page
      return;
    }
    this.body.innerHTML = html;
    this.body.scrollTop = 0;
  }
}

customElements.define('quick-order-sheet', QuickOrderSheet);
